import { create } from "zustand";

export interface PendingDocument {
  id: string; // Temporary ID (e.g., crypto.randomUUID())
  file: File;
  objectType: string;
  name: string;
  uploadedAt: Date;
}

interface PendingDocumentsStore {
  pendingDocuments: PendingDocument[];
  addPendingDocument: (document: PendingDocument) => void;
  removePendingDocument: (id: string) => void;
  clearPendingDocuments: (objectType?: string) => void;
}

export const usePendingDocumentsStore = create<PendingDocumentsStore>((set) => ({
  pendingDocuments: [],
  addPendingDocument: (document) =>
    set((state) => ({
      pendingDocuments: [...state.pendingDocuments, document],
    })),
  removePendingDocument: (id) =>
    set((state) => ({
      pendingDocuments: state.pendingDocuments.filter((doc) => doc.id !== id),
    })),
  clearPendingDocuments: (objectType) =>
    set((state) => ({
      pendingDocuments: objectType
        ? state.pendingDocuments.filter((doc) => doc.objectType !== objectType)
        : [],
    })),
}));
